<template>
  <div>
    <el-row>
      <el-col :span="12" :offset="6">
        <div style="font-size:20px;margin-bottom:20px">Users</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="2" :offset="16">
        <router-link to="/users/add" v-if="$store.getters.isAdmin"><i class="el-icon-circle-plus-outline" style="color:#409EFF;font-size:24px"></i></router-link>
        <a href="#/users" @click="refreshData()"><i class="el-icon-refresh" style="color:#409EFF;font-size:24px" /></a>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12" :offset="6">
        <el-table :data="users" :row-class-name="rowStatus" empty-text="No records">
          <el-table-column prop="userLogin" label="Login"/>
          <el-table-column prop="firstName" label="First Name"/>
          <el-table-column prop="lastName" label="Last Name"/>
            <el-table-column prop="isAdmin" label="Admin" >
            <template slot-scope="scope">
              <i class="el-icon-star-off" v-bind:style="{display: scope.row.isAdmin?'':'none'}"></i>
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="120">
            <template v-slot:default="scope">
              <el-button @click="editUser(scope.$index)" icon="el-icon-edit-outline" circle></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<style>
.el-table .disabled-row {
  color: salmon;
}
</style>

<script>
import axios from "axios";

export default {
  name: "Users",
  data() {
    return {
      users: []
    };
  },
  mounted() {
    this.refreshData();
  },
  computed: {
    hasGlobalError: function() {
      return this.globalError !== "";
    }
  },
  methods: {
    rowStatus({ row, _ }) {
      if (!row.isActive) return "disabled-row";
      return ";";
    },

    editUser(idx){
      let id = this.users[idx].externalId;
      this.$router.push({ name: "User", params: { id: id } });
    },
    onAddUser() {
      this.$router.push({ name: "User", params: { id: 'add' } });
    },
    refreshData() {
      var url = `${process.env.VUE_APP_API}application-users`;

      axios
        .get(url, {
          headers: {
            Authorization: window.sessionStorage.getItem("token")
          }
        })
        .then(result => {
          this.users = result.data;
          this.users.sort((u1,u2)=>u1.userLogin.localeCompare(u2.userLogin));
        });
    }
  }
};
</script>
